<template>
    <div class="main bg-waves">
        <section id="brn-error" class="diagonal">
            <BorderDecoration class="top-left outside d-none d-md-block" style="left: -50px; top: 25px" :primary="'var(--color-secondary)'" :secondary="'var(--color-gray-light)'"/>
            <div class="container text-center">
                <img class="illustration" src="/assets/images/illustrations/broken-bike.png" alt="error-404">
                <ChalkDecoration class="m-auto">
                    <h2 class="text-uppercase">Page not found!</h2>
                    <h5>This page doesn't exist. Please try to search something other.</h5>
                </ChalkDecoration>
                <a href="javascript:void(0);" class="btn btn-primary mt-5" @click="getBack()">
                    <i class="bi bi-arrow-left"></i> Back
                </a>
            </div>
        </section>
    </div>
</template>

<script>
import BorderDecoration from "../components/elements/BorderDecoration";
import ChalkDecoration from "../components/elements/ChalkDecoration";
export default {
    name: "Error404",
    components: {ChalkDecoration, BorderDecoration},
    methods: {
        getBack() {
            history.back();
        }
    }
}
</script>

<style scoped>

</style>
